import { initializeApp } from "firebase/app";

const firebaseConfig = {
    apiKey: "AIzaSyBf23qugR4nDlPvrAjZd6hD8ko9DzPyHPE",
    authDomain: "emcii-token.firebaseapp.com",
    projectId: "emcii-token",
    storageBucket: "emcii-token.firebasestorage.app",
    messagingSenderId: "326609965768",
    appId: "1:326609965768:web:8fb4118a0d39a881fb4bfd",
    measurementId: "G-38WLLE194R"
  };
  
  // Initialize Firebase
const app = initializeApp(firebaseConfig);


export default app;